var map = {
	"./beacons/beacons.module": [
		"./src/app/wisefly/beacons/beacons.module.ts",
		"common",
		"beacons.module"
	],
	"./content/content.module": [
		"./src/app/wisefly/content/content.module.ts",
		"common",
		"content.module"
	],
	"./manage/manage.module": [
		"./src/app/wisefly/manage/manage.module.ts",
		"common",
		"manage.module"
	],
	"./multilingual/multilingual.module": [
		"./src/app/wisefly/multilingual/multilingual.module.ts",
		"common",
		"multilingual.module"
	],
	"./newplaces/newplaces.module": [
		"./src/app/wisefly/newplaces/newplaces.module.ts",
		"common",
		"newplaces.module"
	],
	"./passengertips/passengertips.module": [
		"./src/app/wisefly/passengertips/passengertips.module.ts",
		"common",
		"passengertips.module"
	],
	"./places/places.module": [
		"./src/app/wisefly/places/places.module.ts",
		"common",
		"places.module"
	],
	"./placesbud/placesbud.module": [
		"./src/app/wisefly/placesbud/placesbud.module.ts",
		"common",
		"placesbud.module"
	],
	"./reports/reports.module": [
		"./src/app/wisefly/reports/reports.module.ts",
		"common",
		"reports.module"
	],
	"./transportation/transportation.module": [
		"./src/app/wisefly/content/transportation/transportation.module.ts",
		"common",
		"transportation.module"
	],
	"./wisefly/wisefly.module": [
		"./src/app/wisefly/wisefly.module.ts",
		"wisefly.module",
		"common"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main